import * as api from '../api'
export const getOrgUnitSDGReport = async (crisId) => {
    return api.get(`/org-unit/${crisId}/sdg`)
}